"use strict";var e=require("./tokeniseString.cjs"),r=require("./upperCaseFirst.cjs");exports.camelCase=function(t){return e.tokeniseString(t).map((function(e,t){return 0===t?e:r.upperCaseFirst(e)})).join("")};
//# sourceMappingURL=camelCase.cjs.map
